import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import logo from '../assets/csf-logo.svg';

/**
 * CSF branded loading indicator
 * - White spinner and text
 * - Centers in viewport by default
 * - Optionally covers full screen with dark background
 */
const CsfLoading = ({ message = 'Loading', fullScreen = true, size = 84, showText = false }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: fullScreen ? 'fixed' : 'relative',
        inset: fullScreen ? 0 : 'auto',
        minHeight: fullScreen ? '100vh' : '240px',
        bgcolor: fullScreen ? '#0b1220' : 'transparent',
        zIndex: 1300,
        color: 'common.white',
      }}
    >
      <Box sx={{ position: 'relative', width: size + 40, height: size + 40 }}>
        {/* Static track */}
        <CircularProgress
          variant="determinate"
          value={100}
          size={size + 40}
          thickness={3}
          sx={{ color: 'rgba(255,255,255,0.15)' }}
        />
        {/* Animated spinner */}
        <CircularProgress
          variant="indeterminate"
          size={size + 40}
          thickness={3}
          sx={{
            color: 'common.white',
            position: 'absolute',
            left: 0,
            top: 0,
            animationDuration: '900ms',
          }}
        />
        {/* Logo in the center */}
        <Box
          component="img"
          alt="CSF"
          src={logo}
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            width: size,
            height: size,
            filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.4))',
            userSelect: 'none',
            pointerEvents: 'none',
          }}
        />
      </Box>

      {showText && (
        <Typography variant="body2" sx={{ mt: 2, color: 'common.white', letterSpacing: 1 }}>
          {message}…
        </Typography>
      )}
    </Box>
  );
};

export default CsfLoading;
